import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// 1 delete
const delete_question_request = () => {
  return {
    type: questionsTypes.publish.request
  }
}

const delete_question_success = (response) => {
  return {
    type: questionsTypes.publish.success,
    payload: response.data
  }
}

const delete_single_question_success = (response) => {
  return {
    type: questionsTypes.publish.single,
    payload: response.data
  }
}

const delete_question_failure = (messages) => {
  return {
    type: questionsTypes.publish.failure,
    payload: messages
  }
}

const delete_question = (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( delete_question_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.delete(
      formatRoute(QUESTIONS_ROUTES.destroy, {id: question_id}),
      {
        params: reqParams
      }
    ).then( response => {
      window.showSnackbar('success', 'The question has been permanently deleted.')
      if ( index ) {
        dispatch( delete_question_success(response) )

      } else {
        dispatch( delete_single_question_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting question"]
      }
      window.showSnackbar('error', errors)
      dispatch( delete_question_failure( errors ) )
    })
  }
}

export {delete_question}



// WEBPACK FOOTER //
// ./src/js/actions/questions/delete.js